
export async function copyLink(href: string) {
  if (!href) { return }

  await navigator.clipboard.writeText(href)
}
